var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasesCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3655 8.29935V5.39357C38.3655 3.33502 36.7347 1.65965 34.7309 1.65965H17.7209L17.0866 0.594416C16.8656 0.224732 16.4741 0 16.053 0H3.63453C1.63078 0 0 1.67538 0 3.73392V35.2661C0 37.3246 1.63078 39 3.63453 39H38.3655C40.3692 39 42 37.3246 42 35.2661V12.0333C42 9.97473 40.3692 8.29935 38.3655 8.29935ZM35.9428 5.39357C35.9428 4.70701 35.3992 4.14855 34.7309 4.14855H19.2052L20.0572 5.57785L21.6781 8.29823H35.9428V5.39357Z",
    fill: "#050E30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 28.17L14.5299 24.7C14.1399 24.31 13.5099 24.31 13.1199 24.7C12.7299 25.09 12.7299 25.72 13.1199 26.11L17.2999 30.29C17.6899 30.68 18.3199 30.68 18.7099 30.29L29.2899 19.71C29.6799 19.32 29.6799 18.69 29.2899 18.3C28.8999 17.91 28.2699 17.91 27.8799 18.3L17.9999 28.17Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasesCompleted);
export default __webpack_public_path__ + "static/media/cases-completed.d5bdcd79.svg";
export { ForwardRef as ReactComponent };